import { UIIcon } from '../config/icons';
import { ABFilterBar } from '../lib/ab/filter-bar';
import { ABProducerSelect } from '../lib/ab/select-admin';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { cCountryDefaultCurrency, cCountryGetValues } from '../lib/mdl/c-country';
import { c_producers, cProducerHasValidPaymentAccount, CProducerId } from '../lib/mdl/c-producer';
import { EBankTransfer, eBankTransferCreate, eBankTransferPaid, eBankTransfersGet, EGeneratePayoutsRequestPayment, EPayablesPendingQuery, EPayablesPendingResponse, ePayablesSetGlobalRatio, ePayablesUpdate, EPayableUpdate, EPayoutItem, EPendingPayable, EPendingPayableItem, ePendingPayablesGet, EProducerPayoutListView, eProducerPayoutsGenerate, eProducerPayoutsList, eProducerPayoutsSend, eProducerPayoutUpdate } from '../lib/mdl/e-payout';
import { the_alt_token } from '../lib/me/login';
import { onAttach } from '../lib/ui/attach';
import { UIButton } from '../lib/ui/component/button';
import { UIDateInput } from '../lib/ui/component/date';
import { UIDialog } from '../lib/ui/component/dialog';
import { UINumberInput, UITextInput } from '../lib/ui/component/input';
import { UILabeled } from '../lib/ui/component/labeled';
import { UISelect } from '../lib/ui/component/select';
import { UITable, UITableDefinition, UITableRow, UITableRowController } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { UICheckbox, UIRadio } from '../lib/ui/component/toggle';
import { addTooltip } from '../lib/ui/component/tooltip';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIAlignment, UIRelPos, UIValue } from '../lib/ui/types';
import { UIViewSpec } from '../lib/ui/view';
import { $amount, YPaymentAmount, YPaymentCurrency } from '../lib/y/amount';
import { YArrayDataSource, YInputDataSource } from '../lib/y/data-source';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $on } from '../lib/y/events';
import { $fn } from '../lib/y/fn';
import { $form } from '../lib/y/form';
import { $format } from '../lib/y/format';
import { $location } from '../lib/y/location';
import { yEqual } from '../lib/y/object';
import { $date, $time } from '../lib/y/time';
import { YCountryId, YMonthSpec } from '../lib/y/types';

function getMonthValues(all?: boolean) {
    const date_values: UIValue<YMonthSpec>[] = [];
    for(let date = $time.make(2016, 11); date.add(1, $time.month).is_past; date = date.add(1, $time.month)) {
        date_values.unshift({ key: date.format('yyyyMM') as YMonthSpec, name: date.format('MMMM yyyy') })
    }

    if(all)
        date_values.unshift({ key: 'all' as YMonthSpec, name: 'All months' });

    return date_values;
}

class AmountDialog extends UIDialog<number> {
    constructor(title: string, scale: number, value: number) {
        super({ close: true, classes: 'm-500' });

        const amount = new UINumberInput({ scale: scale, decimal: true, required: true });
        amount.value = value;

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', title),
            amount,
            $el.DIV('l-button-row', new UIButton({
                title: "Apply", classes: 'm-round m-compact', on_click: () => {
                    this.dismiss(amount.value || 0)
                }
            }))
        ]));

        onAttach(this, () => { amount.selectAll() });
    }
}

class GenerateDialog extends UIDialog<EPayablesPendingResponse> {
    constructor(payments: EGeneratePayoutsRequestPayment[], query: EPayablesPendingQuery) {
        super({ close: true, classes: 'm-500' });

        const date = new UIDateInput({ placeholder: 'Invoice date', required: true });
        date.value = $date.today();

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Generate payments'),
            date,
            $el.DIV('l-button-row', [
                new UIButton({
                    title: "Cancel", classes: 'm-round m-compact m-hollow', on_click: () => {
                        this.dismiss(null);
                    }
                }),
                new UIButton({
                    title: "Generate", classes: 'm-round m-compact', on_click: () => {
                        return eProducerPayoutsGenerate(date.value, payments, query).then(response => {
                            this.dismiss(response);
                        });
                    }
                })
            ])
        ]));
    }
}

class PayableInfoDialog extends UIDialog<EPayablesPendingResponse> {
    constructor(payable: EPendingPayable, item: EPendingPayableItem, query: EPayablesPendingQuery) {
        super({ close: true, classes: 'm-500' });

        const description = new UITextInput({ placeholder: 'Description', required: true });
        description.value = item.description;
        const producer = new ABProducerSelect({ required: true })
        producer.value = payable.producer_id;

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Change payment info'),
            description,
            producer,
            $el.DIV('l-button-row', [
                new UIButton({
                    title: "Cancel", classes: 'm-round m-compact m-hollow', on_click: () => {
                        this.dismiss(null);
                    }
                }),
                new UIButton({
                    title: "Change", classes: 'm-round m-compact', on_click: () => {
                        return ePayablesUpdate([item.payable], { description: description.value, producer_id: producer.value }, query).then(response => {
                            this.dismiss(response);
                        });
                    }
                })
            ])
        ]));
    }
}

class SendDialog extends UIDialog<EProducerPayoutListView[]> {
    constructor(payments: EProducerPayoutListView[]) {
        super({ close: true, classes: 'm-500' });

        const send_email = new UICheckbox({ title: 'Send email' });

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Send payments'),
            send_email,
            $el.DIV('l-button-row', [
                new UIButton({
                    title: "Cancel", classes: 'm-round m-compact m-hollow', on_click: () => {
                        this.dismiss(null);
                    }
                }),
                new UIButton({
                    title: "Confirm", classes: 'm-round m-compact', on_click: () => {
                        return eProducerPayoutsSend(payments.map(p => p.id), send_email.value).then(response => {
                            this.dismiss(response);
                        });
                    }
                })
            ])
        ]));
    }
}

class PayDialog extends UIDialog {
    constructor(payouts: EProducerPayoutListView[]) {
        super({ close: true, classes: 'm-500' });

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Make payment order'),
            $el.DIV('l-button-row', [
                new UIButton({
                    title: "Cancel", classes: 'm-round m-compact m-hollow', on_click: () => {
                        this.dismiss(null);
                    }
                }),
                new UIButton({
                    title: "Confirm", classes: 'm-round m-compact', on_click: () => {
                        return eBankTransferCreate(payouts.map(p => p.id)).then(() => {
                            this.dismiss(true);
                        }, uiToast);
                    }
                })
            ])
        ]));
    }
}

interface PendingRow {
    payable?: EPendingPayable;
    item?: EPendingPayableItem;
    total?: boolean;

    currency: YPaymentCurrency;
    description: string;
    info: string;
    warning?: boolean;
    generated: boolean;
    is_disabled?: boolean;
    is_fixed: boolean;

    vat: number;
    quantity: number;
    value: YPaymentAmount;
    amount: YPaymentAmount;
    mg_amount: YPaymentAmount;
    adjustment: number;
}

function makePendingPayoutRow(p: EPendingPayable, query: EPayablesPendingQuery): PendingRow {
    let quantity = 0;
    let value = $amount.zero(p.currency);
    let amount = $amount.zero(p.currency);
    let mg_amount = $amount.zero(p.currency);
    let adjustment_inv = 0;
    let is_fixed = true;
    let vat = -2;

    for(const i of p.items) {
        if(vat == -2)
            vat = i.vat;
        else if(vat != i.vat)
            vat = -1;
        quantity += i.quantity;
        if(!$amount.canAdd(i.value, value) || !$amount.canAdd(i.amount, amount) || !$amount.canAdd(i.mg_amount, mg_amount)) {
            $log('app', 'invalid currency for item', i, 'in payment', p);
            continue;
        }

        value = $amount.add(value, i.value);
        amount = $amount.add(amount, i.amount);
        mg_amount = $amount.add(mg_amount, i.mg_amount);
        if(i.adjustment > 0)
            adjustment_inv += i.amount.value / i.adjustment;
        if(!i.is_fixed)
            is_fixed = false;
    }

    const producer = c_producers.maybe(p.producer_id)!;

    return {
        payable: p,

        currency: p.currency,
        description: (query.month ? producer?.name : p.month) || 'Unknown producer',
        info: p.payout_type,
        warning: !cProducerHasValidPaymentAccount(producer) || !producer.org_name || !producer.org_number,
        generated: p.is_generated,

        vat: vat,
        quantity: quantity,
        value: value,
        amount: amount,
        mg_amount: mg_amount,
        adjustment: amount.value / adjustment_inv,
        is_fixed: is_fixed
    };
}

function makePendingPayoutItemRow(i: EPendingPayableItem, p: EPendingPayable): PendingRow {
    const date = $date(i.date);

    let description = i.description;
    // if(i.extra_info) {
    //     description += ' (' + i.extra_info + ')';
    // }

    return {
        payable: p,
        item: i,

        currency: p.currency,
        description: description,
        info: date.n ? date.format('yyyy-MM-dd') : '',
        generated: p.is_generated,
        vat: i.vat,
        quantity: i.quantity,
        value: i.value,
        amount: i.amount,
        mg_amount: i.mg_amount,
        adjustment: i.adjustment,
        is_fixed: i.is_fixed,
        is_disabled: i.is_disabled
    }
}

export class AdminEconomyPendingScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        const fillTable = () => {
            if(!pending_response) return;
            const rows = pending_response.payouts.map(i => makePendingPayoutRow(i, query));
            count.number = rows.length;
            source.data = rows;
            const currency = cCountryDefaultCurrency(query.country);

            const total: PendingRow = {
                total: true,
                description: 'Total',
                currency: currency,
                info: '',
                generated: true,
                vat: -2,
                quantity: 0,
                value: $amount.zero(currency),
                amount: $amount.zero(currency),
                mg_amount: $amount.zero(currency),
                adjustment: 0,
                is_fixed: false
            }

            for(const r of rows) {
                total.quantity += r.quantity;
                if(!$amount.canAdd(r.value, total.value) || !$amount.canAdd(r.amount, total.amount) || !$amount.canAdd(r.mg_amount, total.mg_amount)) {
                    $log('app', 'mismatched currency for row', r, 'in pending payments', total, total.value.currency);
                    continue;
                }
                total.value = $amount.add(total.value, r.value);
                total.amount = $amount.add(total.amount, r.amount);
                total.mg_amount = $amount.add(total.mg_amount, r.mg_amount);
            }

            if(total_body)
                table.removeExtra(total_body);
            total_body = table.addExtra(new YArrayDataSource([total]));

            if(query.month) {
                const revenue = pending_response.infos[query.month];
                payout_percentage.value = revenue.global_ratio;
                summary.textContent = '\u00a0(' + (total.amount.value / revenue.revenue.value * 100).toFixed(1) + '% of ' + $format.currency(revenue.revenue) + ')\u00a0';
            }
        };

        const count = new ABObjectCount('payments');
        const generate_button = new UIButton({
            kind: 'k-filter', icon: UIIcon.ROCKET_LAUNCH, title: 'Generate', classes: 'm-inline', on_click: () =>
                new GenerateDialog(source.checked_models.map(r => ({ month: r.payable!.month, payable_ids: r.payable!.items.map(i => i.payable) })), query).present().then(response => {
                    pending_response = response;
                    fillTable();
                })
        });
        const summary = $el.SPAN();

        const filter_bar = new ABFilterBar({
            on_filter: fillTable,
            right_content: [generate_button, count],
            no_header: true
        });

        const filters = filter_bar.filters;

        const country_select = new UISelect(cCountryGetValues());
        const date_select = new UISelect(getMonthValues(), { searchable: true });
        const producer_select = new ABProducerSelect({});
        const payout_percentage = new UINumberInput({ chars: 5 });

        filters.addWidgets([country_select, date_select, producer_select, new UILabeled(payout_percentage, { before: 'Base %' }), summary]);

        let query: EPayablesPendingQuery;
        let pending_response: EPayablesPendingResponse | undefined
        let total_body: any; // TODO: fix

        const vatHandler = (row: UITableRow<PendingRow>) => {
            const r = row.item;
            if(r.generated) return;
            new AmountDialog("VAT", 1, row.item.vat < 0 ? 0 : row.item.vat).present().then(v => {
                const payables = r.item ? [r.item.payable] : r.payable!.items.map(p => p.payable);
                const payment_row = row.parent || row;

                ePayablesUpdate(payables, { vat: v }, query).then(response => {
                    pending_response = response;
                    const payment = response.payouts.find(p => p.is_generated == false && p.payout_type == r.payable!.payout_type && p.producer_id == r.payable!.producer_id && p.month == r.payable!.month && p.country == r.payable!.country);
                    if(payment)
                        payment_row.assign(makePendingPayoutRow(payment, query));
                })
            });
        }

        const adjustmentHandler = (row: UITableRow<PendingRow>, text: string, scale: number, adjustment: number, current: number, real_current: number) => {
            $log('app', 'adjustmentHandler', row, text, scale, adjustment, current, real_current);
            const r = row.item;
            if(r.generated) return;
            new AmountDialog(text, scale, current).present().then(v => {
                const payables = r.item ? [r.item.payable] : r.payable!.items.map(p => p.payable);
                const payment_row = row.parent || row;

                $log('app', 'resolved', v, adjustment * v / current, adjustment * v / real_current);

                const update: EPayableUpdate = r.is_fixed ? { price_fixed: { value: Math.round(r.amount.value / r.quantity * v / real_current), currency: r.amount.currency } } : { adjustment: adjustment * v / real_current };

                ePayablesUpdate(payables, update, query).then(response => {
                    pending_response = response;
                    const payment = response.payouts.find(p => p.is_generated == false && p.payout_type == r.payable!.payout_type && p.producer_id == r.payable!.producer_id && p.month == r.payable!.month && p.country == r.payable!.country);
                    if(payment)
                        payment_row.assign(makePendingPayoutRow(payment, query));
                })
            });
        }

        generate_button.ui_hide();

        payout_percentage.on_enter = () => {
            const v = payout_percentage.value;
            if(v && query.month && pending_response && v != pending_response.infos[query.month].global_ratio) {
                pending_response.infos[query.month].global_ratio = v;
                ePayablesSetGlobalRatio(query.month, query.country, v, query).then(response => {
                    if(response) {
                        pending_response = response;
                        fillTable();
                    }
                })

            }
            payout_percentage.blur();
        };

        $on(payout_percentage, 'blur', () => {
            if(query.month && pending_response && payout_percentage.value != pending_response.infos[query.month].global_ratio) {
                payout_percentage.value = pending_response.infos[query.month].global_ratio;
            }
        });

        const def = new UITableDefinition<PendingRow>();
        def.addCheckbox({
            expansion: (td, row) => {
                if(row.item.item && row.item.item.payable_kind == 'video_ppv')
                    td.ui_add($el.SPAN('tl-ppv-badge', 'PPV'));
            }
        });
        def.addCustom({
            title: 'Producer', width: 160, decorator: (td, row) => {
                const p = row.item;
                td.ui_add(p.description);
                if(p.warning) {
                    td.ui_add('\u00a0');
                    const icon = $el.ICON(UIIcon.TRIANGLE_EXCLAMATION | UIIcon.WEIGHT_SOLID, 'warning');
                    addTooltip('Missing information', row, { position: UIRelPos.Above, offset: 12, anchor: icon, hover: icon });
                    td.appendChild(icon);
                }
                td.classList.add('u-clickable');
            }, comparator: (a, b, o) => {
                return o * $fn.ICOMPARE(a.description, b.description);
            }, on_click: row => { row.expand(true) }
        });
        def.addValue(p => p.info, { title: 'Payment', width: -90 });
        def.addValue(p => p.quantity, $fmt.NUMBER, { title: 'Tickets', width: -110 });
        def.addValue(p => p.vat < 0 ? ':' : '' + p.vat, {
            title: 'VAT', width: -90, on_click: row => {
                vatHandler(row);
            }, decorator: (td, row) => {
                if(!row.item.generated)
                    td.classList.add('u-clickable');
            }
        });
        def.addValue(p => p.value, $fmt.CURRENCY, { title: 'Value', width: -120 });
        def.addValue(p => p.quantity ? $amount.div(p.value, p.quantity) : $amount.zero(p.currency), $fmt.CURRENCY, { title: 'per ticket', width: -110 });
        def.addValue(p => p.mg_amount.value ? p.mg_amount : undefined, $fmt.CURRENCY, { title: 'MG', width: -110 });
        def.addValue(p => $amount.sub(p.amount, p.mg_amount), $fmt.CURRENCY, {
            title: 'Payout', width: -110, on_click: row => {
                adjustmentHandler(row, 'Total payout amount', 100, row.item.adjustment, Math.round(row.item.amount.value), row.item.amount.value);
            }, alignment: UIAlignment.Right, decorator: (td, row) => {
                if(!row.item.generated)
                    td.classList.add('u-clickable');
            }
        });
        def.addValue(p => p.quantity ? $amount.div(p.amount, p.quantity) : $amount.zero(p.currency), $fmt.CURRENCY, {
            title: 'per ticket', width: -110, on_click: row => {
                adjustmentHandler(row, 'Payout amount per ticket', 100, row.item.adjustment, Math.round(row.item.amount.value / row.item.quantity), row.item.amount.value / row.item.quantity);
            }, decorator: (td, row) => {
                if(!row.item.generated)
                    td.classList.add('u-clickable');
            }
        });
        def.addValue(p => p.value.value ? p.amount.value / p.value.value : undefined, $fmt.PERCENTAGE, {
            title: 'Perc.', width: -110, on_click: row => {
                adjustmentHandler(row, 'Set percentage', 1, row.item.adjustment, Math.round(row.item.amount.value / row.item.value.value * 10000) / 100, row.item.amount.value / row.item.value.value * 100);
            }, decorator: (td, row) => {
                if(!row.item.generated)
                    td.classList.add('u-clickable');
            }
        });
        def.addValue(p => (p.generated || p.is_fixed) ? undefined : p.adjustment * 100, $fmt.OPTIONAL($fmt.NUMBERMAX(1), ''), {
            title: 'Adjust.', width: -110, on_click: row => {
                if(!row.item.is_fixed) {
                    if(row.item.adjustment)
                        adjustmentHandler(row, 'Set adjustment', 1, row.item.adjustment, Math.round(row.item.adjustment * 10000) / 100, row.item.adjustment * 100);
                    else
                        adjustmentHandler(row, 'Set adjustment', 1, 1, 100, 100);
                }
            }, decorator: (td, row) => {
                if(!row.item.generated && !row.item.is_fixed)
                    td.classList.add('u-clickable');
            }
        });
        def.addButtons([
            {
                icon: UIIcon.THUMBS_UP, tooltip: 'Generate', when: p => !p.generated && !p.item && !p.total, action: p => {
                    const payable_ids = p.payable!.items.map(i => i.payable);
                    return new GenerateDialog([{ month: p.payable!.month, payable_ids }], query).present().then(response => {
                        pending_response = response;
                        fillTable();
                    });
                }
            },
            {
                icon: UIIcon.PENCIL, tooltip: 'Change info', when: p => !!p.item && !p.generated, action: p => {
                    return new PayableInfoDialog(p.payable!, p.item!, query).present().then(response => {
                        pending_response = response;
                        fillTable();
                    });
                }
            },
            {
                icon: UIIcon.BAN, tooltip: 'Disable', when: p => !!p.item && !p.generated, action: p => {
                    ePayablesUpdate([p.item!.payable], { is_disabled: true }, query).then(response => {
                        pending_response = response;
                        fillTable();
                    });
                }
            },
            {
                icon: UIIcon.BAN, tooltip: 'Enable', when: p => !!p.item && !!p.is_disabled, action: p => {
                    ePayablesUpdate([p.item!.payable], { is_disabled: false }, query).then(response => {
                        pending_response = response;
                        fillTable();
                    });
                }
            }
        ], { width: -62 });

        def.controller = row => {
            if(row.item.total) {
                row.classList.add('m-total');
            } else if(row.item.generated) {
                row.classList.add('m-generated');
            }

            return {
                value_expand: () => {
                    if(row.item.payable && !row.item.item) {
                        return row.item.payable.items.map(i => makePendingPayoutItemRow(i, row.item.payable!))
                    }

                    return;
                }

            }
        }
        def.preference_prefix = 'payments_pending';

        const source = new YArrayDataSource<PendingRow>();
        const table = new UITable(def, source, { progressive: false });

        const by_month = new UIRadio({ title: 'By month' });
        const by_producer = new UIRadio({ title: 'By producer', group: by_month.group });
        by_month.value = true;

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-wider', [
                $el.DIV('l-input-row', [by_month, by_producer]),
                filter_bar,
                table,
            ])),
        ]);

        const doQuery = () => {
            const new_query: EPayablesPendingQuery = { country: country_select.value! };
            if(by_month.value) {
                new_query.month = date_select.value!
                date_select.ui_show();
                producer_select.ui_hide();
                payout_percentage.ui_show();
                summary.ui_show();
            } else {
                new_query.producer = producer_select.value!;
                date_select.ui_hide();
                producer_select.ui_show();
                payout_percentage.ui_hide();
                summary.ui_hide();
            }

            if(yEqual(new_query, query)) return;
            query = new_query;
            ePendingPayablesGet(query).then(response => {
                pending_response = response;
                fillTable();
            });
        };

        by_month.value = true;
        country_select.value = country_select.values[0].key;
        date_select.value = date_select.values[0].key;
        producer_select.value = producer_select.values[0].key;

        $on(country_select, 'value', doQuery);
        $on(date_select, 'value', doQuery);
        $on(producer_select, 'value', doQuery);
        $on(by_month, 'value', doQuery);
        $on(by_producer, 'value', doQuery);

        $on(source, 'checked', () => {
            const models = source.checked_models;
            generate_button.ui_show(undefined, models.length > 0 && models.every(m => !m.generated && !m.item));
        });

        this.onViewDidReappear = fillTable;

        doQuery();
    }
}

interface PayoutItemRowController extends UITableRowController<EPayoutItem> {
    description: UITextInput;
    tickets: UINumberInput;
    amount: UINumberInput;
    vat: UINumberInput;
}

class PayoutScreen extends UIScreen {
    constructor(private _payment?: EProducerPayoutListView) {
        super();

        this.title = _payment ? 'Payment' : 'New payment';
    }

    protected override async fillContent(content: UIViewSpec) {
        const payment = this._payment;
        const is_paid = payment && !!payment.paid_on;

        content.classList.add('tl-admin-page');

        const producer = new ABProducerSelect({ required: true });
        const payment_type = new UITextInput({ required: true, disabled: !!payment }); // TODO: change to select
        const date = new UIDateInput({ required: true });

        const info_name = new UITextInput;
        const info_org_name = new UITextInput;
        const info_org_number = new UITextInput;
        const info_vat_id = new UITextInput;
        const info_address = new UITextInput({ lines: 3 });

        const items_def = new UITableDefinition<EPayoutItem, PayoutItemRowController>();

        if(is_paid) {
            items_def.addValue(p => p.description + (p.time ? ' - ' + $time(p.time).format('d MMM yyyy HH:mm') : ''), { title: 'Event', width: 100 });
            items_def.addValue(p => p.quantity, $fmt.NUMBER, { title: 'Tickets', width: -100 });
            items_def.addValue(p => p.amount_total, $fmt.CURRENCY, { title: 'Total', width: -100 });
        } else {
            items_def.addCustom({
                title: 'Event', width: 100, decorator: (td, row) => {
                    const item = row.item;
                    if(item.description)
                        td.ui_add(item.description + ' - ' + $time(item.time)?.format('d MMM yyyy HH:mm'))
                    else
                        td.ui_add(row.controller!.description)
                }
            });
            items_def.addCustom({
                title: 'Tickets', width: -100, decorator: (td, row) => {
                    if(row.item.description)
                        td.ui_add(row.controller!.tickets)
                }
            });
            items_def.addCustom({ title: 'Total', width: -100, decorator: (td, row) => { td.ui_add(row.controller!.amount) } });
        }

        items_def.addCustom({ title: 'VAT %', width: -100, decorator: (td, row) => { td.ui_add(row.controller!.vat) } });

        if(!is_paid) {
            items_def.addButtons([{ icon: UIIcon.TRASH_CAN, tooltip: 'Remove', action: (_p, row) => { items.removeIndex(row.index) } }], { width: -31 });
        }

        items_def.controller = row => {
            const item = row.item;

            const description = new UITextInput;
            const tickets = new UINumberInput;
            const amount = new UINumberInput({ scale: 100 });
            const vat = new UINumberInput;

            description.value = item.description;
            tickets.value = item.quantity;
            amount.value = item.amount_total.value;
            vat.value = item.vat;

            return {
                description: description,
                tickets: tickets,
                amount: amount,
                vat: vat,
                commit: () => {
                    item.description = description.value;
                    item.quantity = tickets.value!;
                    item.amount_total.value = amount.value!;
                    item.vat = vat.value!;
                }
            }
        }

        const items = new YInputDataSource<EPayoutItem>;

        const form = $form({ producer, payment_type, date, items, info: $form({ name: info_name, org_name: info_org_name, org_number: info_org_number, vat_id: info_vat_id, address: info_address }) });

        if(payment)
            form.value = payment;

        const section = $el.FORM('ui-section w-form l-form', [
            new UILabeled(producer, { above: 'Producer' }),
            new UILabeled(payment_type, { above: 'Payment type' }),
            new UILabeled(date, { above: 'Invoice date' }),
            new UILabeled(info_name, { above: 'Producer name' }),
            new UILabeled(info_org_name, { above: 'Organization name' }),
            new UILabeled(info_org_number, { above: 'Organization number' }),
            new UILabeled(info_vat_id, { above: 'VAT ID' }),
            new UILabeled(info_address, { above: 'Address' }),
            new UILabeled(new UITable(items_def, items), { above: 'Items' }),
            // !is_paid && new UIButton({ title: '+ New item', kind: 'k-text', on_click: () => { items.push({ description:'', quantity: 0, amount: 0, vat: 6 }, true) }})
        ]);

        // if(payment && !is_paid) {
        //     $tl.getPendingSessionsPayments(payment.producer, payment.payment_type).then(sessions => {
        //         if(!sessions.length) return;

        //         const pending = new UIDataAdapter((i: TLProducerPaymentItem, e) => {
        //             const add = new UIButton({ title: 'Add', kind: 'k-text', classes: 'm-inline', on_click: () => {
        //                 items.push(i);
        //                 pending.remove(e);
        //             }})
        //             return $el.B([i.event_name + ' - ' + $time(i.session_time).format('d MMM yyyy HH:mm') + ' - ', add]);
        //         }, sessions)

        //         section.ui_add([
        //             $el.H3('heading', 'Available sessions'),
        //             new UIList(pending)
        //         ]);
        //     });
        // }

        const button = new UIButton({
            icon: UIIcon.THUMBS_UP, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                eProducerPayoutUpdate(payment!.id, form.value).then(() => {
                    $location.pop();
                }, uiToast);
            }
        });

        addTooltip(payment ? 'Update' : 'Create', button, { offset: 8, hover: button, position: UIRelPos.Above });

        content.ui_add([section, button]);
    }
}

function canTransfer(p: EProducerPayoutListView) {
    return !p.bank_transfer_id && p.amount.value > 0;
}

function canDelete(_p: EProducerPayoutListView) {
    // return !p.transfers?.length;
    return false
}

function canEdit(_p: EProducerPayoutListView) {
    return xavis_experiments;
}

function paidStatus(p: EProducerPayoutListView) {
    if(p.paid_on)
        return $date(p.paid_on).format('yyyy-MM-dd');
    if(p.bank_transfer_id)
        return 'paying';
    if(p.amount.value == 0)
        return '-';
    return 'pending';
}

export class AdminPayoutsScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        const fixButtons = () => {
            const models = source.checked_models;
            download_button.ui_show(undefined, models.length > 0)
            if(models.length > 0)
                download_button.link = `/docs/producer_invoices?token=${the_alt_token}&ids=${models.map(p => p.id).join(',')}`;
            send_button.ui_show(undefined, models.length > 0 && models.every(p => !p.sent_at));
            pay_button.ui_show(undefined, models.length > 0 && models.every(canTransfer));
        }

        const fillTable = () => {
            if(!all_payments) return;
            count.number = all_payments.length;
            source.data = all_payments;
            fixButtons();
        };

        const count = new ABObjectCount('payouts');

        const download_button = new UIButton({ kind: 'k-filter', icon: UIIcon.DOWNLOAD, title: 'Invoices', link: '' });
        const send_button = new UIButton({
            kind: 'k-filter', icon: UIIcon.PAPER_PLANE, title: 'Send', on_click: () => {
                return new SendDialog(source.checked_models).present().then(reload);
            }
        });
        const pay_button = new UIButton({
            kind: 'k-filter', icon: UIIcon.EURO_SIGN, title: 'Make transfer', on_click: () => {
                return new PayDialog(source.checked_models).present().then(reload);
            }
        });

        download_button.ui_hide();
        send_button.ui_hide();
        pay_button.ui_hide();

        const filter_bar = new ABFilterBar({
            on_filter: fillTable,
            right_content: [download_button, send_button, pay_button, count],
            no_header: true
        });

        const filters = filter_bar.filters;

        let current_country: YCountryId | undefined;
        let current_month: YMonthSpec | undefined;
        let current_producer: CProducerId | undefined; // TODO: see if we can skip the '' and use undefined as the zero value in the UISelect
        let all_payments: EProducerPayoutListView[] | undefined;

        const country_select = new UISelect(cCountryGetValues());
        const month_values = getMonthValues();
        const month_select = new UISelect(month_values, { searchable: true });
        const producer_select = new ABProducerSelect({ all_producers: true });

        filters.addWidgets([country_select, month_select, producer_select]);

        const def = new UITableDefinition<EProducerPayoutListView>();
        def.addCheckbox();
        def.addValue(p => p.month + '-' + p.number.toString().padStart(3, '0'), { title: 'Number', width: -120 });
        def.addValue(p => c_producers.maybe(p.producer_id)?.name ?? 'unknown', { title: 'Producer', width: 160 });
        def.addValue(p => p.payout_type, { title: 'Type', width: -100 });
        def.addValue(p => p.quantity, $fmt.NUMBER, { title: 'Tickets', width: -100 });
        def.addValue(p => p.amount, $fmt.CURRENCY, { title: 'Sum payable', width: -130 });
        def.addValue(p => c_producers.maybe(p.producer_id)?.payout_destination?.number || '', { title: 'Bank account', width: -180 });
        def.addValue(p => !!p.sent_at, $fmt.CHECKMARK, { title: 'Sent', width: -64 });
        def.addValue(p => paidStatus(p), { title: 'Paid', width: -100 });

        def.addButtons([
            {
                icon: UIIcon.PENCIL, tooltip: 'Edit', when: canEdit, action: p => {
                    $location.push({ transient: new PayoutScreen(p) });
                }
            },
            {
                icon: UIIcon.TRASH_CAN, tooltip: 'Delete', when: canDelete, action: _p => {
                    // $tl.removeProducerPayment(p.id).then(() => {
                    //     reload();
                    // });
                }
            },
            { icon: UIIcon.DOWNLOAD, tooltip: 'Download', link: p => '/docs/producer_invoice/' + p.id + '?format=pdf&token=' + the_alt_token }
        ], { width: -120 });
        def.preference_prefix = 'payout_sent_invoices';

        const source = new YArrayDataSource<EProducerPayoutListView>();
        const table = new UITable(def, source, { progressive: false });

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                filter_bar,
                table,
            ])),
        ]);

        let initializing = true;

        const reload = () => {
            if(initializing || !current_country) return;
            eProducerPayoutsList(current_country, current_month, current_producer).then(payments => {
                all_payments = payments;
                fillTable();
            });
        }

        $on(country_select, 'value', v => {
            if(v == undefined || v === current_country) return;
            current_country = v;
            reload();
        })

        $on(month_select, 'value', v => {
            if(v == undefined || v === current_month) return;
            current_month = v;
            reload();
        });

        $on(producer_select, 'value', v => {
            if(v == undefined || v === current_producer) return;
            if(v == 'all') {
                const values = getMonthValues(false);
                if(current_month == 'all') {
                    current_month = values[0].key;
                    month_select.values = values;
                    month_select.value = current_month;
                } else {
                    month_select.values = values;
                }
            } else if(current_producer == 'all') {
                month_select.values = getMonthValues(true);
            }

            current_producer = v;
            reload();
        });

        $on(source, 'checked', fixButtons);

        country_select.value = country_select.values[0].key;
        current_month = month_values[0].key;
        month_select.value = current_month;
        current_producer = 'all' as CProducerId;
        producer_select.value = current_producer;

        initializing = false;

        reload();

        this.onViewDidReappear = reload;
    }
}

class BankTransferPaidDialog extends UIDialog {
    constructor(transfer: EBankTransfer) {
        super({ close: true, classes: 'm-500' });

        const date = new UIDateInput({ placeholder: 'Payment date', required: true });
        date.value = $date.today();

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Mark as paid'),
            date,
            $el.DIV('l-button-row', [
                new UIButton({
                    title: "Cancel", classes: 'm-round m-compact m-hollow', on_click: () => {
                        this.dismiss(null);
                    }
                }),
                new UIButton({
                    title: "Confirm", classes: 'm-round m-compact', on_click: () =>
                        eBankTransferPaid(transfer.id, date.value).then(() => {
                            this.dismiss(true);
                        }, uiToast)
                })
            ])
        ]));
    }
}

export class AdminBankTransfersScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const all_transfers = await eBankTransfersGet();

        const doSearch = () => {
            let transfers = all_transfers;
            if(!filters.value.show_paid)
                transfers = transfers.filter(t => !$date(t.paid_on).n);
            count.number = transfers.length;
            source.data = transfers;
        }

        const count = new ABObjectCount('transfers');

        const filter_bar = new ABFilterBar({
            on_filter: doSearch,
            right_content: [count],
            no_header: true
        });

        const filters = filter_bar.filters;
        filters.addCheckbox('show_paid', 'Show paid', true);

        const def = new UITableDefinition<EBankTransfer>();
        def.addValue(p => $time(p.created_at), $fmt.DATE(), { title: 'Created on', width: 120 });
        def.addValue(p => $date(p.paid_on), $fmt.DATE(), { title: 'Paid on', width: 120 });
        def.addValue(p => p.items.length, $fmt.NUMBER, { title: 'Payments', width: 120 });
        def.addValue(p => p.items.reduce((v, a) => $amount.add(v, a.amount), $amount.zero()), $fmt.CURRENCY, { title: 'Total amount', width: 120 });

        def.addButtons([
            { icon: UIIcon.DOWNLOAD, tooltip: 'Download', link: p => '/docs/bank_transfer/' + p.id + '?token=' + the_alt_token },
            {
                icon: UIIcon.TRASH_CAN, tooltip: 'Delete', when: _p => xavis_experiments, action: _p => {
                    // $tl.removeBankTransfer(p.id).then(() => { $location.reload() });
                }
            },
            {
                icon: UIIcon.CHECK, tooltip: 'Mark as paid', when: p => !$date(p.paid_on)?.n, action: p => {
                    new BankTransferPaidDialog(p).present().then(() => { $location.reload() });
                }
            }
        ], { width: -93 });

        def.preference_prefix = 'economy_bank_payments';

        const source = new YArrayDataSource<EBankTransfer>();

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-narrow', [
                filter_bar,
                new UITable(def, source),
            ])),
        ]);

        doSearch();
    }
}